import script from "./ColorExplorerView.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorExplorerView.vue?vue&type=script&setup=true&lang=js"

import "./ColorExplorerView.vue?vue&type=style&index=0&id=a2ccaeaa&scoped=true&lang=css"

import exportComponent from "/home/simon/workspace/tasman/3palette/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2ccaeaa"]])

export default __exports__